import React from 'react'
import { t } from '@lingui/macro'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  IconButton,
  Tooltip,
  Typography,
  TablePagination,
} from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { FormSubmission } from '@/core/models/form.model'
import {
  ETHICS_STATUS_COLOR,
  getEthicsPatientName,
  getEthicsSubmissionStatusLabel,
  getEthicsSubmissionSummary,
} from '../lib/formatEthicsSubmission'

type EthicsSubmissionsListProps = {
  submissions: FormSubmission[]
  totalCount: number
  page: number
  rowsPerPage: number
  onPageChange: (page: number) => void
  onRowsPerPageChange: (rowsPerPage: number) => void
  onViewSubmission: (submission: FormSubmission) => void
}

export function EthicsSubmissionsList({
  submissions,
  totalCount,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  onViewSubmission,
}: EthicsSubmissionsListProps) {
  if (submissions.length === 0) {
    return (
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">
          {t`No ethical questions found`}
        </Typography>
      </Paper>
    )
  }

  return (
    <Paper>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                {t`Date`}
              </TableCell>
              <TableCell>
                {t`Patient`}
              </TableCell>
              <TableCell>
                {t`Summary`}
              </TableCell>
              <TableCell>
                {t`Status`}
              </TableCell>
              <TableCell align="right">
                {t`Actions`}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {submissions.map((submission) => (
              <TableRow key={submission._id} hover sx={{ cursor: 'pointer' }} onClick={() => onViewSubmission(submission)}>
                <TableCell>{new Date(submission.createdAt).toLocaleDateString()}</TableCell>
                <TableCell>{getEthicsPatientName(submission)}</TableCell>
                <TableCell>{getEthicsSubmissionSummary(submission)}</TableCell>
                <TableCell>
                  <Chip
                    label={getEthicsSubmissionStatusLabel(submission.status)}
                    color={ETHICS_STATUS_COLOR[submission.status] || 'default'}
                    size="small"
                  />
                </TableCell>
                <TableCell align="right">
                  <Tooltip title={t`View details`}>
                    <IconButton
                      size="small"
                      onClick={(event) => {
                        event.stopPropagation()
                        onViewSubmission(submission)
                      }}
                    >
                      <VisibilityIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={totalCount}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={(_event, newPage) => onPageChange(newPage)}
        onRowsPerPageChange={(event) => onRowsPerPageChange(parseInt(event.target.value, 10))}
        rowsPerPageOptions={[5, 10, 25]}
      />
    </Paper>
  )
}
